<template>
  <div class="flex flex-row mt-8 mb-2 sm:mb-6 text-2xl">
    <div class="trophy-container">
      <font-awesome-icon :icon="['fas', 'trophy']" class="pt-1" :class="{ 'pop-animation': isScorePopping }"/>
    </div>
    <div class="score-container pl-1 font-extrabold" :class="{ 'pop-animation': isScorePopping }">
      {{ displayScore }}
    </div>
  </div>
  <svg width="0" height="0">
    <defs>
      <linearGradient id="trophy-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" style="stop-color:#68D391; stop-opacity:1" />
        <stop offset="100%" style="stop-color:#4FD1C5; stop-opacity:1" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useCountUp } from '../../composables/useCountUp.js';

const props = defineProps({
  isScorePopping: Boolean,
  score: Number
})

const displayScore = useCountUp(() => props.score, { duration: 500 });
</script>

<style>
.trophy-container svg * {
  fill: url(#trophy-gradient);
}

.score-container {
  color: transparent;
  background: linear-gradient(90deg, #68D391, #4FD1C5);
  -webkit-background-clip: text;
  background-clip: text;
  display: inline;
}
</style>
